import { type ReactNode } from 'react';

import styles from './shimmer.module.scss';

type ShimmerProps = {
  children: ReactNode;
};

/** Sweeps a highlight across its own text, for labels that are still loading. */
export const Shimmer = ({ children }: ShimmerProps): JSX.Element => (
  <span className={styles.shimmer}>{children}</span>
);
